export function getFlowMode() {
    if (typeof window === 'undefined') return {autoRedirect: false};

    const params = new URLSearchParams(window.location.search);
    return {autoRedirect: params.get('t-flow') === 'true'};
}
